import * as Papa from 'papaparse';
import { RESET_STATE_TEMPLATE_CREATE_UPDATE, SET_TEMPLATE_CREATE_UPDATE } from 'Screens/KnowledgeBaseEditCreate/actions/Actions';
import api from 'services/api';
import axios, { CancelToken } from 'axios';
import { getWorkspaces } from 'Screens/Workspaces/actions/Actions';
import head from 'lodash/head';
import { CURRENT_API_VERSION } from 'services/api/connector';
import { selectQueryParam } from 'store/Filters/selectors';
import {
  resetFilters, setFilter, setOrderBy, setPageNumber
} from 'store/Filters/actions';
import { selectVulnsList, selectVulnsSelected } from 'store/Manage/selectors';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { KB_FILTERS } from 'store/Filters/constants';
import { newGetVulns } from 'store/Manage/filterActions';
import { selectTemplatesSelected } from 'store/KnowledgeBase/selectors';

export const GET_DATA_VULN_TEMPLATE_START = 'GET_DATA_VULN_TEMPLATE_START';
export const GET_DATA_VULN_TEMPLATE_SUCCESS = 'GET_DATA_VULN_TEMPLATE_SUCCESS';
export const GET_DATA_VULN_TEMPLATE_FAIL = 'GET_DATA_VULN_TEMPLATE_FAIL';
export const SHOW_VULN_TEMPLATE_MODAL_NEW = 'SHOW_VULN_TEMPLATE_MODAL_NEW';
export const SHOW_VULN_TEMPLATE_MODAL_EDIT = 'SHOW_VULN_TEMPLATE_MODAL_EDIT';
export const HIDE_VULN_TEMPLATE_MODAL = 'HIDE_VULN_TEMPLATE_MODAL';
export const IMPACT_SELECTED_VULN_TEMPLATE = 'IMPACT_SELECTED_VULN_TEMPLATE';
export const CREATE_UPDATE_VULN_TEMPLATE_START = 'CREATE_UPDATE_VULN_TEMPLATE_START';
export const CREATE_UPDATE_VULN_TEMPLATE_ERROR = 'CREATE_UPDATE_VULN_TEMPLATE_ERROR';
export const CREATE_UPDATE_VULN_TEMPLATE_SUCCESS = 'CREATE_UPDATE_VULN_TEMPLATE_SUCCESS';
export const HIDE_ERROR_VULN_TEMPLATE_NEW_UPDATE = 'HIDE_ERROR_VULN_TEMPLATE_NEW_UPDATE';
export const VULN_TEMPLATE_SELECTED = 'VULN_TEMPLATE_SELECTED';
export const VULN_TEMPLATE_SELECTED_ALL = 'VULN_TEMPLATE_SELECTED_ALL';
export const SHOW_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE = 'SHOW_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE';
export const HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE = 'HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE';
export const DELETE_VULN_TEMPLATE = 'DELETE_VULN_TEMPLATE';
export const HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE_SUCCEED = 'HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE_SUCCEED';
export const SHOW_MODAL_IMPORT_VULN_TEMPLATE = 'SHOW_MODAL_IMPORT_VULN_TEMPLATE';
export const HIDE_MODAL_IMPORT_VULN_TEMPLATE = 'HIDE_MODAL_IMPORT_VULN_TEMPLATE';
export const IMPORT_FILE_VULN_TEMPLATE = 'IMPORT_FILE_VULN_TEMPLATE';
export const IMPORT_FILE_VULN_TEMPLATE_SUCCESS = 'IMPORT_FILE_VULN_TEMPLATE_SUCCESS';
export const IMPORT_FILE_VULN_TEMPLATE_ERROR = 'IMPORT_FILE_VULN_TEMPLATE_ERROR';
export const SET_VISIBILITY_CREATE_MODAL_KB = 'SET_VISIBILITY_CREATE_MODAL_KB';
export const GET_DATA_TEMPLATES_SORT = 'GET_DATA_TEMPLATES_SORT';
export const GET_DATA_TEMPLATES_FILTER = 'GET_DATA_TEMPLATES_FILTER';
export const GET_VULNS_COUNT_SUCCESS = 'GET_VULNS_COUNT_SUCCESS';
export const GET_VULNS_COUNT_FAIL = 'GET_VULNS_COUNT_FAIL';
export const SET_KNOWLEDGE_BASE_PAGE = 'SET_KNOWLEDGE_BASE_PAGE';
// Template CSV uploading
export const SET_CSV_KB_FILE_INDEX_MANAGE = 'SET_CSV_KB_FILE_INDEX_MANAGE';
export const SET_UPLOAD_STATE_KB = 'SET_UPLOAD_STATE_KB';
export const UPLOAD_CSV_KB_UPDATE_PERCENT = 'UPLOAD_CSV_KB_UPDATE_PERCENT';
export const UPLOAD_CSV_KB_ERROR = 'UPLOAD_CSV_KB_ERROR';
export const CANCEL_REQUEST_UPLOAD_CSV_KB = 'CANCEL_REQUEST_UPLOAD_CSV_KB';
export const SET_NAME_INTO_FILE_ERROR_LIST_CSV_KB = 'SET_NAME_INTO_FILE_ERROR_LIST_CSV_KB';
export const RESET_FILE_STATE_KB = 'RESET_FILE_STATE_KB';
export const SET_FILES_TO_UPLOAD_KB = 'SET_FILES_TO_UPLOAD_KB';

// Summary: Validate csv headers
function equalAsSets (a, b) {
  if (a.length !== b.length) return false;
  let flag = true;

  a.forEach((elem) => {
    if (b.indexOf(elem) === -1) flag = false;
  });

  b.forEach((elem) => {
    if (a.indexOf(elem) === -1) flag = false;
  });

  return flag;
}

// Summary: Insert vuln templates in the csv file
function loadCSV (data, dispatch) {
  const datas = [];
  const url = `/_api/${CURRENT_API_VERSION}/vulnerability_template`;

  Papa.parse(data, {
    worker: true,
    header: true,
    skipEmptyLines: true,
    step (results) {
      if (results.data) {
        datas.push(results.data);
      }
    },
    complete () {
      const { length } = datas;
      let counter = 0;
      // TODO: Modify backend for use only one request, so add api call.
      datas.forEach((vulnt) => {
        const vulntCopy = vulnt;

        if (!vulntCopy.easeofresolution || vulntCopy.easeofresolution === '') vulntCopy.easeofresolution = null;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify(vulntCopy),
          headers: {
            'Content-type': 'application/json'
          }
        }).then((result) => {
          if (result.ok) {
            counter += 1;
            if (length === counter) {
              dispatch({ type: IMPORT_FILE_VULN_TEMPLATE_SUCCESS });
            }
          } else {
            dispatch({ type: IMPORT_FILE_VULN_TEMPLATE_ERROR, errorMessage: `Some templates could not be imported. Error: ${result.statusText}` });
          }
        }).catch((error) => {
          dispatch({ type: IMPORT_FILE_VULN_TEMPLATE_ERROR, errorMessage: `Some templates could not be imported. Error: ${error}` });
        });
      });
    }
  });
}

const getTemplateRowsFailureCallback = (error) => ({
  type: GET_DATA_VULN_TEMPLATE_FAIL,
  data: error
});

const getWorkspaceRowsSuccedCallback = (data) => ({
  type: GET_DATA_VULN_TEMPLATE_SUCCESS,
  data: data.rows,
  vulnTemplateCount: data.total_rows
});

export function getVulnsTemplateCount () {
  return async (dispatch) => {
    try {
      const data = await api.manage.getTemplates();
      dispatch({ type: GET_VULNS_COUNT_SUCCESS, total: data.total_rows });
    } catch (e) {
      dispatch({ type: GET_VULNS_COUNT_FAIL, error: e.response || 'An error has occurred.' });
    }
  };
}

export function getData () {
  return async (dispatch, getState) => {
    dispatch({ type: GET_DATA_VULN_TEMPLATE_START });
    const state = getState();
    const params = selectQueryParam('knowledgeBase', state);
    try {
      const response = await api.knowledgeBase.fetchTemplates(params);
      dispatch(getVulnsTemplateCount());

      return dispatch(getWorkspaceRowsSuccedCallback(response));
    } catch (e) {
      return dispatch(getTemplateRowsFailureCallback(e));
    }
  };
}

export function setVisibilityCreateModal (value) {
  return (dispatch) => {
    dispatch({ type: SET_VISIBILITY_CREATE_MODAL_KB, value });

    if (!value) dispatch({ type: RESET_STATE_TEMPLATE_CREATE_UPDATE, value });
  };
}

export function showVulnTemplateModalEdit () {
  return (dispatch, getState) => {
    const { templatesSelected } = getState().knowledgeBase;
    dispatch({ type: SET_TEMPLATE_CREATE_UPDATE, template: head(templatesSelected).doc });
    dispatch({ type: SET_VISIBILITY_CREATE_MODAL_KB, value: true });
  };
}

export function vulnTemplateSelected (selectionInfo) {
  return (dispatch) => {
    dispatch({
      type: VULN_TEMPLATE_SELECTED, selectionInfo
    });
  };
}

// Summary: Show confirmation modal when user delete vuln template/s
export function showVulnTemplateModalDelete () {
  return (dispatch) => {
    dispatch({ type: SHOW_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE });
  };
}

// Summary: Hide confirmation modal when user delete vuln template/s
export function hideVulnTemplateModalDelete () {
  return (dispatch) => {
    dispatch({ type: HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE });
  };
}

// Summary: Delete vuln template from database
export function deleteVulnTemplateSelected () {
  return (dispatch, getState) => {
    const templatesSelected = selectTemplatesSelected(getState());
    const templateIds = templatesSelected.map(temp => temp.id);
    dispatch({ type: DELETE_VULN_TEMPLATE });
    try {
      api.knowledgeBase.deleteTemplates({ ids: templateIds });
      dispatch({ type: HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE_SUCCEED });
    } catch {
      dispatch({ type: HIDE_MODAL_DELETE_CONFIRMATION_VULN_TEMPLATE_SUCCEED });
    }
    dispatch(getData());
  };
}

// Summary: Show popup for csv import
export function showVulnTemplateModalImport () {
  return (dispatch) => {
    dispatch({ type: SHOW_MODAL_IMPORT_VULN_TEMPLATE });
  };
}

// Summary: Hide popup for csv import
export function hideVulnTemplateModalImport () {
  return (dispatch) => {
    dispatch({ type: HIDE_MODAL_IMPORT_VULN_TEMPLATE });
  };
}

// Summary: Init the csv import process
export function importFile (csv) {
  return (dispatch) => {
    dispatch({ type: IMPORT_FILE_VULN_TEMPLATE });

    const reader = new FileReader();
    reader.onload = function () {
      const text = reader.result;
      const expectedHeader = ['cwe', 'description', 'exploitation', 'name', 'references', 'resolution'];
      const actualHeader = text.split('\n').shift().trim().toLowerCase()
        .split(',');

      if (equalAsSets(expectedHeader, actualHeader)) {
        loadCSV(csv, dispatch);
      } else {
        document.body.style.cursor = 'default';
        dispatch({ type: IMPORT_FILE_VULN_TEMPLATE_ERROR, errorMessage: 'It appears your CSV has the wrong headers. Headers MUST be present.' });
      }
    };
    reader.readAsText(csv);
  };
}

export function sortData (sorting) {
  return (dispatch) => {
    dispatch(setOrderBy('knowledgeBase', sorting));
    dispatch(getData());
  };
}

export function setFilterTemplates (filter) {
  return (dispatch) => {
    dispatch({ type: GET_DATA_TEMPLATES_FILTER, filter });
    if (filter) dispatch(setFilter('knowledgeBase', KB_FILTERS.kbByName(`%${filter}%`)));
    else dispatch(resetFilters('knowledgeBase'));

    dispatch(getData());
  };
}

export function setFilesCount (files) {
  return (dispatch) => {
    dispatch({ type: SET_FILES_TO_UPLOAD_KB, files });
  };
}

export function setFileIndex (index) {
  return (dispatch) => {
    dispatch({ type: SET_CSV_KB_FILE_INDEX_MANAGE, index });
  };
}

export function setUploadState (state) {
  return (dispatch) => {
    dispatch({ type: SET_UPLOAD_STATE_KB, state });
  };
}

export function resetFileUploadState () {
  return (dispatch) => {
    dispatch({ type: RESET_FILE_STATE_KB });
  };
}

export function uploadFile (file) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SET_UPLOAD_STATE_KB, state: 'PROCESSING' });
      const response = await api.faraday.getSession();

      const cancelTokenSource = CancelToken.source();

      const fd = new FormData();
      fd.append('csrf_token', response.csrf_token);
      fd.append('file', file);

      await axios.post(`/_api/${CURRENT_API_VERSION}/vulnerability_template/bulk_create`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: async (progressEvent) => {
          dispatch({ type: UPLOAD_CSV_KB_UPDATE_PERCENT, progressEvent });
          if (Math.round((100 * progressEvent.loaded) / progressEvent.total) === 100) {
            const index = getState().knowledgeBase.fileIndex - 1;
            dispatch({ type: SET_CSV_KB_FILE_INDEX_MANAGE, index });
          }
        },
        cancelToken: cancelTokenSource.token
      });

      const currentIndex = getState().knowledgeBase.fileIndex;
      if (currentIndex < 0) {
        dispatch({ type: SET_UPLOAD_STATE_KB, state: 'FINISHED' });
        dispatch(getWorkspaces());
        dispatch(getData());
      } else {
        dispatch({ type: SET_UPLOAD_STATE_KB, state: 'PROCESSED' });
      }
    } catch (e) {
      if (!e.message || e.message !== 'cancel') {
        const currentIndex = getState().knowledgeBase.fileIndex;
        dispatch({ type: SET_NAME_INTO_FILE_ERROR_LIST_CSV_KB, name: file.name });
        const filesCount = getState().knowledgeBase.filesToUpload.length;
        if (filesCount === 1) {
          dispatch({ type: UPLOAD_CSV_KB_ERROR, error: e.response && e.response.data.message ? e.response.data.message : 'Couldn\'t upload your file. Please try again.' });
        }
        if (currentIndex < 0) {
          dispatch({ type: SET_UPLOAD_STATE_KB, state: 'FINISHED' });
          dispatch(getWorkspaces());
        } else {
          dispatch({ type: SET_UPLOAD_STATE_KB, state: 'PROCESSED' });
        }
      } else {
        dispatch({ type: CANCEL_REQUEST_UPLOAD_CSV_KB });
      }
    }
  };
}

export function setPage (page) {
  return async (dispatch) => {
    dispatch(setPageNumber('knowledgeBase', page));
    dispatch(getData());
  };
}

export const applyTemplate = (template, fields) => async (dispatch, getState) => {
  const vulnsSelected = selectVulnsSelected(getState());
  const workspaceSelected = selectCurrentWorkspace(getState());
  const vulnsList = selectVulnsList(getState());

  const data = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const field in fields) {
    if (fields[field]) {
      if (field === 'exploitation') data.severity = template[field];
      if (field === 'refs') {
        template[field] = template[field].map(name => { return { name, type: 'other' }; });
      }
      if (field === 'customfields') {
        data.custom_fields = template[field];
      }
      data[field] = template[field];
    }
  }

  const vulnPromises = vulnsSelected.map((vuln) => api.manage.updateVuln(workspaceSelected, { _id: vuln._id, ...data }));
  try {
    const res = await Promise.allSettled(vulnPromises);
    res.forEach(({ value }) => {
      const index = vulnsList.findIndex((x) => value._id === x.id || value._id === x._id);
      vulnsList[index] = value;
    });
    dispatch(newGetVulns());
  } catch (error) { }
};
